function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "04_Icons/Menu/Kalender",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Outline",
  fill: "#00172E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30,0 L30,30 L0,30 L0,0 L30,0 Z M29.5,0.5 L0.5,0.5 L0.5,29.5 L29.5,29.5 L29.5,0.5 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26,7 L26,30 L4,30 L4,7 L26,7 Z M25.5,7.5 L4.5,7.5 L4.5,29.5 L25.5,29.5 L25.5,7.5 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 13,
  y: 16,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 17,
  y: 16,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 21,
  y: 16,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 9,
  y: 20,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 13,
  y: 20,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 17,
  y: 20,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 21,
  y: 20,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 9,
  y: 24,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 13,
  y: 24,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 17,
  y: 24,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 21,
  y: 24,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-10",
  points: "25.7727277 11.25 25.7727277 11.75 4.22727273 11.75 4.22727273 11.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  points: "7.75 6.25 7.75 8.75 7.25 8.75 7.25 6.25"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  points: "22.75 6.25 22.75 8.75 22.25 8.75 22.25 6.25"
})));
function SvgBeReservationsCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_Icons/Menu/Kalender") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeReservationsCalendar);
export default __webpack_public_path__ + "static/media/BEReservations_calendar.030d75916e9a90c0b5996a42fb3aa253.svg";
export { ForwardRef as ReactComponent };